// ----- NON Application specific data -----------------------------------------------------------------

// Get View Data, parameter: replicaid and view name/alias
export const baseurl_viewdata = "forms_views_api/viewdata";

// Get View Data, parameter: replicaid and view name/alias
export const baseurl_viewdesign = "forms_views_api/viewdesign";

// Get Document Data, parameter: replicaid and UNID
export const baseurl_documentdata = "forms_views_api/documentdata";

// Get Document Design, parameter: replicaid and form name
export const baseurl_documentdesign = "forms_views_api/documentdesign";

// Create Document: replicaid
export const baseurl_createdocument = "forms_views_api/createdocument";

export const coldef_unid = {
  headerName: "UNID",
  field: "unid",
  position: 0,
  rowGroup: false,
  icon: false,
  sortable: true,
  hide: true,
};

export const login_title = "Welcome to SIT ToDo Sample App";
export const login_text = "To be able to use the application, a registration is required.";
export const login_error = "An error occurred, please try again.";
export const spinner_text = "Loading ...";
export const cancel_text = "Are you sure you want to leave the document, all changes are lost?";
export const btn_login_title = "Login";
export const btn_save_title = "Save";
export const btn_cancel_title = "Cancel";
export const copyright_text = `Copyright © SIT GmbH ${new Date().getFullYear()}`;
export const icon_expand = "icons/actn154.gif";
export const icon_collapse = "icons/actn155.gif";
export const msg_no_selection = "No rows are selected.";

export default {
  baseurl_viewdata,
  spinner_text,
  cancel_text,
  btn_login_title,
  btn_save_title,
  btn_cancel_title,
  copyright_text,
  login_title,
  login_text,
  login_error,
  msg_no_selection,
};
